import { render, staticRenderFns } from "./informdisclosure.vue?vue&type=template&id=40214ade&scoped=true&"
import script from "./informdisclosure.vue?vue&type=script&lang=js&"
export * from "./informdisclosure.vue?vue&type=script&lang=js&"
import style0 from "./informdisclosure.vue?vue&type=style&index=0&id=40214ade&scoped=scoped&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40214ade",
  null
  
)

export default component.exports